import lang from "@/views/modules/Invitees/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-invitee",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            invitee: {},
            lang:[],
        }
    },
    mounted() {
        this.getInvitee();
        this.lang = lang;
    },
    methods: {
        saveInvitee() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/invitees/' + self.$route.params.id, self.invitee).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getInvitee() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/invitees/' + self.$route.params.id).then(function (response) {
                self.invitee = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}